interface ProjectDetailsContentProps {
  name: string;
  salicNumber: string;
  proponent: string;
  cnpj: string;
  logline: string;
  productionPlan: string;
}

export function ProjectDetailsContent({
  name,
  salicNumber,
  proponent,
  cnpj,
  logline,
  productionPlan,
}: ProjectDetailsContentProps) {
  return (
    <div className="flex flex-col gap-[30px] items-start w-full">
      {/* Project Title Section */}
      <div className="flex flex-col gap-[10px] items-start w-full">
        <p className="font-['Plus_Jakarta_Sans'] font-bold leading-normal text-white text-[24px] w-[989px]">
          Detalhes do Projeto - {name}
        </p>
        <div className="flex gap-[10px] items-start font-['Plus_Jakarta_Sans'] font-normal text-[#d1d1d1] text-[14px] leading-[0] whitespace-pre w-full">
          <p className="leading-normal">
            <span>Número Salic: </span>
            <span className="font-semibold text-[#f6f6f6]">{salicNumber}</span>
          </p>
          <p className="leading-normal">
            <span>Produtora: </span>
            <span className="font-semibold text-[#f6f6f6]">
              {proponent} | {cnpj}
            </span>
          </p>
        </div>
        <p className="font-['Plus_Jakarta_Sans'] font-normal leading-[1.4] text-[#f6f6f6] text-[14px] w-full">
          {logline}
        </p>
      </div>

      {/* Horizontal Divider */}
      <div className="h-[1px] w-full bg-[#888888]/20" />

      {/* Production Plan Section */}
      <div className="flex flex-col gap-[6px] items-start w-full text-[16px]">
        <p className="font-['Plus_Jakarta_Sans'] font-bold leading-normal text-white w-[989px]">
          Plano de Produção - Detalhar seu cronograma e estrutura do projeto:
        </p>
        <p className="font-['Plus_Jakarta_Sans'] font-normal leading-[1.4] text-[#d1d1d1] text-[14px] w-full whitespace-pre-wrap">
          {productionPlan}
        </p>
      </div>
    </div>
  );
}
